import React from "react";
import { IDS } from "@/constants/testIds";

const stats = [
  { k: "TVL_SECURED", v: "$1.2B+", d: "across launched protocols" },
  { k: "CONTRACTS_SHIPPED", v: "42", d: "audited & live on mainnet" },
  { k: "VALIDATORS_RUN", v: "12 / 12", d: "global solana fleet" },
  { k: "ZERO_CRITICAL", v: "100%", d: "pre-launch audits since 2022" },
];

const Stats = () => {
  return (
    <section
      data-testid={IDS.stats}
      className="relative py-20 lg:py-28 border-t border-[rgba(0,255,65,0.12)] bg-[#050505]"
    >
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10">
        <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#00FF41]">
          // 04 — Telemetry
        </div>

        <div className="mt-8 grid gap-px bg-[rgba(0,255,65,0.18)] border border-[rgba(0,255,65,0.18)] md:grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => (
            <div
              key={s.k}
              data-testid={IDS.statItem(i)}
              className="bg-[#0a0a0a] p-8 group hover:bg-[#0e0e0e] transition-colors"
            >
              <div className="text-[10px] uppercase tracking-[0.28em] text-zinc-500">
                &gt;&gt;&gt; {s.k}
              </div>
              <div className="mt-4 font-mono text-4xl lg:text-5xl text-[#00FF41] glow-text tracking-tight">
                {s.v}
              </div>
              <div className="mt-3 text-[12px] text-zinc-400">{s.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
